
import React, { Suspense, lazy } from 'react';
import ErrorBoundary from './Routing/ErrorBoundary';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '../src/services/AuthContext';
import { AppThemeProvider } from './context/ThemeContext';
import { Box, Skeleton } from '@mui/material';

const RoutingPage = lazy(() => import('./Routing/RoutingPage'));

const AppSkeleton = () => (
    <Box sx={{ p: 3 }} role="status" aria-label="Loading application">
        <Skeleton variant="rounded" height={64} sx={{ mb: 2 }} />
        <Skeleton variant="rounded" height={160} sx={{ mb: 2 }} />
        <Skeleton variant="rounded" height={360} />
    </Box>
);

function App() {
    const basePath = window.location.pathname.includes("/ClaimMatrix_test1") ? "/ClaimMatrix_test1" : "";
    return (
        <BrowserRouter basename={basePath}>
            <AuthProvider>
                <AppThemeProvider>
                    <ErrorBoundary>
                        <Suspense fallback={<AppSkeleton />}>
                            <RoutingPage />
                        </Suspense>
                    </ErrorBoundary>
                </AppThemeProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;



